import { DefaultThemeInternal } from "../../../internal/themes/DefaultTheme";
import { isNonNullable } from "../../utils";
import { findPropertyDescriptor, REACT_UI_THEME_MARKERS } from "../ThemeHelpers";
export var ThemeFactory = /*#__PURE__*/function () {
  function ThemeFactory() {}

  ThemeFactory.create = function create(theme, baseTheme) {
    var base = baseTheme || DefaultThemeInternal;
    return this.constructTheme(base, theme);
  };

  ThemeFactory.overrideDefaultTheme = function overrideDefaultTheme(theme) {
    // copying theme variables
    ThemeFactory.getKeys(DefaultThemeInternal).forEach(function (variableName) {
      var descriptor = findPropertyDescriptor(theme, variableName);
      Object.defineProperty(DefaultThemeInternal, variableName, descriptor);
    }); // copying theme markers

    Object.values(REACT_UI_THEME_MARKERS).forEach(function (marker) {
      var descriptor = findPropertyDescriptor(theme, marker.key);
      Object.defineProperty(DefaultThemeInternal, marker.key, descriptor);
    });
  };

  ThemeFactory.getKeys = function getKeys(theme) {
    var keys = [];

    while (isNonNullable(theme)) {
      Object.keys(theme).forEach(function (key) {
        if (!keys.includes(key)) {
          keys.push(key);
        }
      }); // TODO: Enable `no-param-reassign` rule.
      // eslint-disable-next-line no-param-reassign

      theme = Object.getPrototypeOf(theme);
    }

    return keys.sort();
  };

  ThemeFactory.constructTheme = function constructTheme(base, theme) {
    var newTheme = Object.create(base);
    Object.keys(theme).forEach(function (propName) {
      var descriptor = Object.getOwnPropertyDescriptor(theme, propName);

      if (descriptor) {
        Object.defineProperty(newTheme, propName, descriptor);
      }
    });
    return Object.freeze(newTheme);
  };

  return ThemeFactory;
}();